import { ChangeDetectorRef, Component, Inject, OnInit, OnDestroy } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormBuilder, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatSelectModule } from '@angular/material/select';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { TranslocoModule, TranslocoService } from '@ngneat/transloco';
import { MAT_DIALOG_DATA, MatDialogRef, MatDialog } from '@angular/material/dialog';
import { CustomAlertService } from 'app/modules/shared/services/alert.service';
import { Subject, takeUntil } from 'rxjs';
import { CdkScrollableModule } from '@angular/cdk/scrolling';
import { SaiDialogHeaderComponent } from 'app/ui/sai-dialog-header/sai-dialog-header.component';

@Component({
  selector: 'app-guidlines',
  standalone: true,
  imports: [
        SaiDialogHeaderComponent,
    CommonModule,
    MatIconModule,
    MatButtonModule,
    MatSelectModule,
    MatFormFieldModule,
    MatSlideToggleModule,
    TranslocoModule,
    FormsModule,
    CdkScrollableModule,
    ReactiveFormsModule],
  templateUrl: './guidlines.component.html',
  styleUrl: './guidlines.component.scss'
})
export class GuidlinesComponent implements OnInit, OnDestroy {

  lang: string = 'en';
  protected _unsubscribeAll = new Subject<void>();
  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    private _dialogRef: MatDialogRef<GuidlinesComponent>,
    private _dialog: MatDialog,
    private fb: FormBuilder,
    private _alertService: CustomAlertService,
    private _changeDetectorRef: ChangeDetectorRef,
    private _translocoService: TranslocoService
  ) { }

  ngOnInit(): void {
    this._translocoService.langChanges$.pipe(takeUntil(this._unsubscribeAll)).subscribe((res) => {
      this.lang = res;
      this._changeDetectorRef.markForCheck();
    })

  }

  save() {
    this._dialogRef.close(true)

  }

  cancel() {
    this._dialogRef.close(false)
  }

  ngOnDestroy(): void {
    this._unsubscribeAll.next();
    this._unsubscribeAll.complete();
  }

}
